import { render, staticRenderFns } from "./DetailsSection.vue?vue&type=template&id=f432848e&scoped=true&"
import script from "./DetailsSection.vue?vue&type=script&lang=js&"
export * from "./DetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSection.vue?vue&type=style&index=0&id=f432848e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432848e",
  null
  
)

export default component.exports